// extracted by mini-css-extract-plugin
export var closeButton = "_m9-1";
export var closeX = "_m9-3";
export var container = "_m9-0";
export var image = "_m9-2";